<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <span class="text-sm">
        {{ $t("student.before_warning_duplicate") }}
        {{ duplicateAccount.total }}
        {{ $t("student.after_warning_duplicate").toLowerCase() }}
      </span>
    </div>
    <div class="md-layout-item md-size-100 md-layout items-center">
      <div class="md-layout-item md-size-20">
        <img
          src="./Img/Back.svg"
          class="cursor-pointer"
          @click="previousAccount"
          v-if="indexAccount"
        />
      </div>
      <div class="md-layout-item md-size-60 md-layout">
        <div class="md-layout-item md-size-100 mt-6">
          <div class="flex flex-col items-center gap-2">
            <img
              class="rounded-full w-40 h-40"
              :src="getAccount.avatar_url || '/img/avt_placeholder.jpg'"
            />
            <h1 class="text-lg font-medium leading-6">
              {{ getAccount.full_name }}
            </h1>
            <p class="text-sm text-[#767575]">{{ getAccount.email }}</p>
            <p class="font-medium text-sm text-[#3C4858]">
              {{ getAccount.birthday }}
            </p>
            <p
              class="text-sm font-medium"
              :class="[
                getAccount.sex === 'Male' ? 'text-[#2D82B5]' : 'text-[#E91E63]'
              ]"
            >
              {{ getAccount.sex }}
            </p>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-20 flex justify-end">
        <img
          class="cursor-pointer"
          src="./Img/Next.svg"
          @click="nextAccount"
          v-if="indexAccount < duplicateAccount.data.length - 1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["duplicateAccount"],
  data() {
    return {
      indexAccount: 0
    };
  },
  computed: {
    getAccount() {
      return this.duplicateAccount.data[this.indexAccount];
    }
  },
  methods: {
    nextAccount() {
      this.indexAccount++;
    },
    previousAccount() {
      this.indexAccount--;
    }
  }
};
</script>

<style lang="scss" scoped></style>
